// extracted by mini-css-extract-plugin
export var promotionLink = "_us-0";